import { createSlice } from '@reduxjs/toolkit';
import { OttVideoDetails } from 'src/types/ott.types';
interface ScheduleDetailsState {
  scheduleDetails: Record<string, any>;
  batchDetails: Record<string, any>;
  ottVideoDetails: OttVideoDetails;
  ottVideoDpps: OttVideoDetails['dpps'];
  ottPlaylistItems: any[];
  bookmarkedVideos: Record<string, boolean>;
  isPWOrg: boolean;
}

const initialState: ScheduleDetailsState = {
  scheduleDetails: {},
  batchDetails: {},
  ottVideoDetails: {} as OttVideoDetails,
  ottVideoDpps: [],
  ottPlaylistItems: [],
  bookmarkedVideos: {},
  isPWOrg: false,
};

export const playerMetaSlice = createSlice({
  name: 'playerMeta',
  initialState,
  reducers: {
    updateScheduleDetails: (
      state,
      action: { payload: { scheduleDetails: Record<string, any> } },
    ) => {
      state.scheduleDetails = { ...action.payload.scheduleDetails };
    },
    updateBatchDetails: (state, action: { payload: { batchDetails: Record<string, any> } }) => {
      state.batchDetails = { ...action.payload.batchDetails };
    },
    updateOttVideoDetails: (state, action: { payload: { ottVideoDetails: OttVideoDetails } }) => {
      state.ottVideoDetails = { ...action.payload.ottVideoDetails };
    },
    updateOttVideoDpps: (state, action: { payload: { ottVideoDpps: any[] } }) => {
      state.ottVideoDpps = action.payload.ottVideoDpps;
    },
    updateOttPlaylistItems: (state, action: { payload: { ottPlaylistItems: any[] } }) => {
      state.ottPlaylistItems = action.payload.ottPlaylistItems;
    },
    updateScheduleDetailsKeys: (state, action: { payload: { key: string; value: any } }) => {
      state.scheduleDetails = {
        ...state.scheduleDetails,
        [action.payload.key]: action.payload.value,
      };
    },
    updateIsPWOrg: (state, action: { payload: { isPWOrg: boolean } }) => {
      state.isPWOrg = action.payload.isPWOrg;
    },
    updateBookmarkedVideos: (
      state,
      action: { payload: { bookmarkedVideos: Record<string, boolean> } },
    ) => {
      state.bookmarkedVideos = { ...state.bookmarkedVideos, ...action.payload.bookmarkedVideos };
    },
    updateSingleBookmark: (
      state,
      action: { payload: { videoId: string; isBookmarked: boolean } },
    ) => {
      state.bookmarkedVideos[action.payload.videoId] = action.payload.isBookmarked;
    },
  },
});

export const {
  updateScheduleDetails,
  updateBatchDetails,
  updateOttVideoDetails,
  updateOttVideoDpps,
  updateOttPlaylistItems,
  updateScheduleDetailsKeys,
  updateIsPWOrg,
  updateBookmarkedVideos,
  updateSingleBookmark,
} = playerMetaSlice.actions;
